var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 1018 1018",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M921.684 444.951a31.783 31.783 0 0031.782-31.782V254.258a63.561 63.561 0 00-18.618-44.947 63.56 63.56 0 00-44.946-18.618H127.129a63.564 63.564 0 00-63.565 63.565v158.911a31.781 31.781 0 0031.783 31.782 63.564 63.564 0 110 127.129 31.783 31.783 0 00-31.782 31.782v158.911a63.566 63.566 0 0063.564 63.564h762.773a63.564 63.564 0 0063.564-63.564V603.862a31.782 31.782 0 00-31.782-31.782 63.565 63.565 0 010-127.129zm-31.782 186.561v131.261H667.426v-95.347h-63.564v95.347H127.129V631.512a127.123 127.123 0 0094.981-122.997 127.127 127.127 0 00-94.981-122.997v-131.26h476.733v95.346h63.564v-95.346h222.476v131.26a127.131 127.131 0 00-94.982 122.997 127.133 127.133 0 0094.982 122.997z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M603.862 413.168h63.564v190.694h-63.564V413.168z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTicket);
export default __webpack_public_path__ + "static/media/iconTicket.27b371cfd1b6d5ffe16c15620b3d884b.svg";
export { ForwardRef as ReactComponent };